var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667185",
    fillRule: "evenodd",
    d: "M15.833 15.5a3.333 3.333 0 0 0 3.334-3.333V3.833A3.333 3.333 0 0 0 15.833.5H4.167A3.333 3.333 0 0 0 .833 3.833v8.333A3.333 3.333 0 0 0 4.167 15.5zM2.5 12.167c0 .92.746 1.666 1.667 1.666h11.666c.92 0 1.667-.746 1.667-1.666v-6.27l-6.262 2.505a3.33 3.33 0 0 1-2.476 0L2.5 5.898zm8.119-5.312 6.88-2.753v-.269c0-.92-.745-1.666-1.666-1.666H4.167c-.92 0-1.667.746-1.667 1.666v.27l6.88 2.752c.398.159.841.159 1.239 0",
    clipRule: "evenodd"
  })));
};
export default SvgMailIcon;